<template>
  <div id="cmdConsole">...</div>
</template>

<script>
export default {
  name: 'cmdConsolePage',
  data() {
    return {};
  },
  methods: {
    // 向页面追加输出内容
    appendConsoleMsg(msg) {
      let pNode = document.createElement('p');
      pNode.textContent = msg;
      document.getElementById('cmdConsole').appendChild(pNode);
    },
    //清除内容
    clearConsoleMsg(msg) {
      document.getElementById('cmdConsole').innerHTML = msg ? msg : '...';
    },
    buttonColorCss(isShow) {
      const classCustom = ['e-control e-btn e-lib e-primary e-flat', 'e-control e-btn e-lib e-flat'];
      let buttons = document.getElementById("cmdConsole").parentNode.parentNode.querySelectorAll('.e-footer-content > button');

      if (isShow) {
        for (let index = 0; index < buttons.length; index++) {
          buttons[index].className = classCustom[0];
        }
      } else {
        for (let index = 0; index < buttons.length; index++) {
          buttons[index].className = classCustom[1];
        }
      }
    }
  }
};
</script>
